import { ColumnComparator } from "../../../shared/data-grid/columnTypes";
import { comparators } from "../../../shared/gridComparators";

const isMissingNumber = (v: unknown): boolean =>
  v === null ||
  v === undefined ||
  v === "" ||
  (typeof v === "number" && Number.isNaN(v));

// Value comparators for the log list's client-side sorting. Missing values
// (null/undefined/""/NaN) compare as smallest — first ascending, last
// descending once the listing query negates for DESC — matching the AG-default
// comparator the pre-TanStack log list used. (The samples grid instead pins
// missing values last in both directions via `gridComparators`.) Missing
// values still need explicit handling: returning 0 for NaN pairs violates
// transitivity and scrambles the non-NaN rows too.
export const numberCompare: ColumnComparator = (a, b) => {
  const aMissing = isMissingNumber(a);
  const bMissing = isMissingNumber(b);
  if (aMissing && bMissing) return 0;
  if (aMissing) return -1;
  if (bMissing) return 1;
  return Number(a) - Number(b);
};

export const dateCompare: ColumnComparator = (a, b) => comparators.date(a, b);
